'use strict';

var app = angular.module('app', [
  'ngSanitize',
  'ngMessages',
  'ngTouch',
  'ngAnimate',
  'ui.router',
  'ui.bootstrap',
  'ngS3upload',
  'ui.bootstrap-slider',
  'ui.mask',
  'validation.match',
  'angular-table',
  'angulartics',
  'angulartics.google.analytics',
  'angular-intro'
]);

//app.factory('PendingModerationInterceptor', function ($q, $injector) {
//  return {
//    responseError: function (rejection) {
//      var $popup = $injector.get('$popup');
//      var $timeout = $injector.get('$timeout');
//      if (_.get(rejection, 'data.name') === 'RM_Moderation') {
//        $timeout(function () {
//          $popup('prompt', { message: 'Your account is still pending approval,<br/>please check back later' });
//        });
//      }
//      return $q.reject(rejection);
//    }
//  };
//});

//app.config(function ($httpProvider) {
//  $httpProvider.interceptors.push('PendingModerationInterceptor');
//});

app.config(function ($locationProvider, $anchorScrollProvider, $animateProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $anchorScrollProvider.disableAutoScrolling();
  $animateProvider.classNameFilter(/ng-animated/);
});

app.run(function ($rootScope, $anchorScroll) {
  $rootScope.$on('$stateChangeSuccess', $anchorScroll);
});

angular.element(document).ready(function () {
  angular.bootstrap(document, ['app']);
});
